import PricingTableDesktop from './Desktop'
import PricingTableMobile from './Mobile'

export { PricingTableDesktop, PricingTableMobile }
